module.exports = __webpack_public_path__ + "static/jumpstart-27763270a0c6210e6e20213ca68a9d96.png";